var map = {
	"./accordion/accordion.js": 445,
	"./anchors/anchors.js": 273,
	"./briefcase/briefcase.js": 309,
	"./burger-menu/burger-menu.js": 997,
	"./clipboard/clipboard.js": 337,
	"./dummy/dummy.js": 205,
	"./footer/footer.js": 49,
	"./form-dropdown/form-dropdown.js": 9,
	"./form-input/form-input.js": 833,
	"./form-textarea/form-textarea.js": 349,
	"./form-upload/form-upload.js": 801,
	"./form/form.js": 487,
	"./func-gallery/func-gallery.js": 365,
	"./gallery/gallery.js": 541,
	"./item-card/slider.item-card.js": 526,
	"./modal/modal.js": 193,
	"./scrollup/scrollup.js": 359,
	"./stack-cards/stack-cards.js": 141
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 212;